import Api from './Api'

export default {
  getBilag (bilagsId) {
    return Api().get('/bilag/' + bilagsId + '.json')
  },
  getBilagPdf (bilagsId) {
    return Api().get('/bilag/' + bilagsId + '/pdf-247.json')
  },
  sendBilagPdf (bilagsId, postData) {
    return Api().post('/bilag/' + bilagsId + '/pdf-247.json', postData)
  },
  getHistoricalBilagsPdf (bilagsId, postData) {
    return Api().post('/bilag/' + bilagsId + '/pdf-247-historical.json', postData)
  },
  finalize (bilagsId, postData) {
    return Api().post('/bilag/' + bilagsId + '/finalize.json', postData)
  }
}



// WEBPACK FOOTER //
// ./src/services/BilagService.js